import React from 'react';

import PageMeta from '../../modules/PageMeta';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import AlertBox from '../../modules/AlertBox';
import AlertMessage from '../../modules/AlertMessage';
import Page from '../../pages/Page';
import PageSection from '../../modules/PageSection';
import ServiceSection from "../ServiceSection";

import qs from "query-string";

class AccountConfirmation extends React.Component {
    _getMessage() {

        const queryParams = this._getQueryString();
        let messageRes = <p>The confirmation link you clicked is no longer valid.
            This may mean that your account has already been confirmed.
            Please contact <a href="mailto:support@rheglobal.com">support@rheglobal.com</a> if you are still having trouble logging in.</p>

        if(queryParams.success === 'true') {
            messageRes = <p>Your account has now been confirmed. Please login using your email and password.</p>;
        }

        return messageRes;
    }

    _getQueryString() {
        return qs.parse(this.props.location.search);
    }

    render() {

        const queryParams = this._getQueryString();

        return (
            <Page>
                <PageMeta title="Account Confirmation" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>
                    <ServiceSection
                        serviceId={queryParams.service}
                    />

                    <PageSection>

                        <AlertMessage>
                            {(queryParams.success === 'true' || queryParams.success === 'false') &&
                                <AlertBox
                                    theme={queryParams.success === 'true' ? 'success' : 'danger'}
                                >
                                    {this._getMessage()}
                                </AlertBox>
                            }
                        </AlertMessage>

                    </PageSection>

                </ContentColumn>

            </Page>
        )
    }
}

export default AccountConfirmation;